// Minimal IndexedDB helper for queue storage
const DB_NAME = 'tlops-portal';
const DB_VERSION = 1;
const STORE = 'queue';

function openDB() {
 return new Promise((resolve, reject) => {
 const req = indexedDB.open(DB_NAME, DB_VERSION);
 req.onupgradeneeded = () => {
 const db = req.result;
 if (!db.objectStoreNames.contains(STORE)) {
 const store = db.createObjectStore(STORE, { keyPath: 'id' });
 store.createIndex('status', 'status', { unique: false });
 store.createIndex('type', 'type', { unique: false });
 }
 };
 req.onsuccess = () => resolve(req.result);
 req.onerror = () => reject(req.error);
 });
}

export async function addQueueItem(item) {
 const db = await openDB();
 return new Promise((resolve, reject) => {
 const tx = db.transaction(STORE, 'readwrite');
 tx.objectStore(STORE).add(item);
 tx.oncomplete = () => resolve(true);
 tx.onerror = () => reject(tx.error);
 });
}

export async function getAllQueueItems() {
 const db = await openDB();
 return new Promise((resolve, reject) => {
 const tx = db.transaction(STORE, 'readonly');
 const req = tx.objectStore(STORE).getAll();
 req.onsuccess = () => resolve(req.result || []);
 req.onerror = () => reject(req.error);
 });
}

export async function updateQueueItem(id, fields) {
 const db = await openDB();
 return new Promise((resolve, reject) => {
 const tx = db.transaction(STORE, 'readwrite');
 const store = tx.objectStore(STORE);
 const getReq = store.get(id);
 getReq.onsuccess = () => {
 const obj = { ...(getReq.result || {}), ...fields };
 store.put(obj);
 };
 tx.oncomplete = () => resolve(true);
 tx.onerror = () => reject(tx.error);
 });
}

export async function deleteQueueItem(id) {
 const db = await openDB();
 return new Promise((resolve, reject) => {
 const tx = db.transaction(STORE, 'readwrite');
 tx.objectStore(STORE).delete(id);
 tx.oncomplete = () => resolve(true);
 tx.onerror = () => reject(tx.error);
 });
}
